import colours from "./colours";

export const agGridThemeVars = {
  "--ag-font-size": "10px",
  "--ag-font-family": "inherit",
  "--ag-header-font-size": "12px",
  "--ag-row-height": "32px",
  "--ag-header-height": "36px",
  "--ag-cell-horizontal-padding": "8px",
  "--ag-row-border-color": "transparent",
  "--ag-cell-horizontal-border": "transparent",
  "--ag-border-color": "transparent",
  "--ag-header-column-separator-display": "none",
  "--ag-header-column-resize-handle-display": "none",
  "--ag-cell-horizontal-border-pinned": colours.background,
};

export const agGridDefaultColDef = {
  sortable: true,
  filter: true,
  resizable: true,
};

export const agGridPinnedActionsCellStyle = {
  display: "flex",
  alignItems: "center",
  borderLeft: `1px solid ${colours.background}`,
};